import { NavigationFlyoutServiceV1Impl } from "./v1";
export { BackButtonClickEventV1Impl, NavigationFlyoutAdminV1Impl } from "./v1/index";
export function defineNavigationFlyoutService(config) {
    return {
        id: "navigation-flyout-service",
        create: () => ({
            "1.0.0": () => ({
                featureService: new NavigationFlyoutServiceV1Impl(config["1.0.0"])
            })
        })
    };
}
